import { inject, injectable } from 'inversify'
import { TYPES } from '@/libs/di/types'

import { createDiagnosisSummary } from './parsers/diagnosis'
import { createKarteUserDetail } from './parsers/karte'

import type { UserID, KarteID } from '@/types/app'
import type { DerekClient } from '@/apis/infrastructures'
import type { UserRepository } from '@/apis/usecases/dataAccesses'
import type {
  DiagnosisKarteResultResponse,
  DiagnosisResultResponse,
} from '@/apis/repositories/models/derek'

@injectable()
export class UserRepositoryImpl implements UserRepository {
  @inject(TYPES.DerekClient) private _derekClient: DerekClient

  public async getDiagnosisSummary(userId: UserID) {
    const { data } = await this._derekClient.get<DiagnosisResultResponse>(
      `/diagnoses/by_user/${userId}`
    )
    return createDiagnosisSummary(data)
  }

  public async getDiagnosisSummaryByKarteId(karteId: KarteID) {
    const { data } = await this._derekClient.get<DiagnosisKarteResultResponse>(
      `/diagnoses/by_karte/${karteId}`
    )
    return {
      summary: createDiagnosisSummary(data),
      user: createKarteUserDetail(data.user),
    }
  }
}
